import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'

export function resolveSchemaOwner(cwd: string, schemaName: string): SchemaOwner {
  return getSchemaOwner(cwd, schemaName) ?? (schemaName === 'settings' ? 'core' : 'user')
}
